"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9617],{

/***/ 73957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82307);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var simplebar_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14863);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(202);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var _ButtonNormal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77911);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);












var PopupV1 = function PopupV1(_ref) {
  var _popupData$images, _popupData$images$lis, _popupData$images$lis2, _popupData$images2, _popupData$images2$li, _popupData$images2$li2, _popupData$data, _popupData$data2, _popupData$data3, _popupData$data4, _popupData$data5, _popupData$data6, _popupData$data7, _popupData$data8, _popupData$data9, _popupData$data10, _popupData$data11;

  var show = _ref.show,
      handleClose = _ref.handleClose,
      no_img = _ref.no_img,
      item = _ref.item,
      title = _ref.title,
      description = _ref.description,
      data = _ref.data,
      subtitle = _ref.subtitle,
      img = _ref.img,
      winWidth = _ref.winWidth;
  var popupData = data; // const [winWidth, setWinWidth] = useState(true)
  // useEffect(() => {
  //     if (window.innerWidth > 767) {
  //         setWinWidth(true)
  //     } else {
  //         setWinWidth(false)
  //     }
  //     window.addEventListener("resize", () => {
  //         if (window.innerWidth > 767) {
  //             setWinWidth(true)
  //         } else {
  //             setWinWidth(false)
  //         }
  //     });
  // }, [])

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledModal, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      show: show,
      item: item,
      onHide: handleClose,
      backdrop: "static",
      keyboard: false,
      className: "gph_modal popup-version-one",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "main_scroll",
        style: {
          height: '100vh'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Body */ .Z.Body, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              className: 'for-close',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                onClick: handleClose,
                className: "modal-close ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("svg", {
                  id: "Button_-_Close",
                  "data-name": "Button - Close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "44",
                  height: "44",
                  viewBox: "0 0 44 44",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Ellipse_18",
                    "data-name": "Ellipse 18",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeWidth: "1",
                    opacity: "0.3",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Ellipse_19",
                    "data-name": "Ellipse 19",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeWidth: "1",
                    strokeDasharray: "0 142",
                    opacity: '0',
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Group_18979",
                    "data-name": "Group 18979",
                    transform: "translate(-3149 -104.5)",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("line", {
                      id: "Line_4",
                      "data-name": "Line 4",
                      x2: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      strokeWidth: "1"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("line", {
                      id: "Line_3877",
                      "data-name": "Line 3877",
                      x1: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      strokeWidth: "1"
                    })]
                  })]
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "modal-data d-flex",
                children: [(popupData === null || popupData === void 0 ? void 0 : (_popupData$images = popupData.images) === null || _popupData$images === void 0 ? void 0 : (_popupData$images$lis = _popupData$images.list) === null || _popupData$images$lis === void 0 ? void 0 : (_popupData$images$lis2 = _popupData$images$lis[0]) === null || _popupData$images$lis2 === void 0 ? void 0 : _popupData$images$lis2.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  sm: 4,
                  className: "modal-data__img",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                    alt: 'Shanta Securities Limited',
                    src: popupData === null || popupData === void 0 ? void 0 : (_popupData$images2 = popupData.images) === null || _popupData$images2 === void 0 ? void 0 : (_popupData$images2$li = _popupData$images2.list) === null || _popupData$images2$li === void 0 ? void 0 : (_popupData$images2$li2 = _popupData$images2$li[0]) === null || _popupData$images2$li2 === void 0 ? void 0 : _popupData$images2$li2.full_path
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data = popupData.data) === null || _popupData$data === void 0 ? void 0 : _popupData$data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
                    children: popupData === null || popupData === void 0 ? void 0 : (_popupData$data2 = popupData.data) === null || _popupData$data2 === void 0 ? void 0 : _popupData$data2.title
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data3 = popupData.data) === null || _popupData$data3 === void 0 ? void 0 : _popupData$data3.link) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data4 = popupData.data) === null || _popupData$data4 === void 0 ? void 0 : _popupData$data4.link)
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data5 = popupData.data) === null || _popupData$data5 === void 0 ? void 0 : _popupData$data5.linkedin) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ButtonNormal__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    icon: true,
                    margin: '30px 0 0 ',
                    hoverColor: '#000',
                    newtablink: popupData !== null && popupData !== void 0 && (_popupData$data6 = popupData.data) !== null && _popupData$data6 !== void 0 && _popupData$data6.linkedin ? popupData === null || popupData === void 0 ? void 0 : (_popupData$data7 = popupData.data) === null || _popupData$data7 === void 0 ? void 0 : _popupData$data7.linkedin : '#',
                    width: '200',
                    hoverBackground: '#000',
                    background: 'transparent',
                    color: '#000',
                    text: 'Linkedin'
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  sm: {
                    span: 7,
                    offset: 1
                  },
                  className: "modal-data__content",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                    className: "scroll-div",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                      md: 12,
                      children: winWidth > 767 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        autoHide: true,
                        style: {
                          maxHeight: 'calc(100vh - 100px)'
                        },
                        children: (popupData === null || popupData === void 0 ? void 0 : (_popupData$data8 = popupData.data) === null || _popupData$data8 === void 0 ? void 0 : _popupData$data8.body) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data9 = popupData.data) === null || _popupData$data9 === void 0 ? void 0 : _popupData$data9.body)
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
                        children: (popupData === null || popupData === void 0 ? void 0 : (_popupData$data10 = popupData.data) === null || _popupData$data10 === void 0 ? void 0 : _popupData$data10.body) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data11 = popupData.data) === null || _popupData$data11 === void 0 ? void 0 : _popupData$data11.body)
                      })
                    })
                  })
                })]
              })
            })
          })]
        })
      })
    })
  });
};

var StyledModal = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PopupV1__StyledModal",
  componentId: "sc-1e63m28-0"
})([".modal-dialog{margin:0;}h4{letter-spacing:1.5px;}"]);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(PopupV1));

/***/ }),

/***/ 96092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93264);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var MyComponent = function MyComponent(_ref) {
  var data = _ref.data,
      id = _ref.id,
      offset = _ref.offset;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledComponent, {
    offset: offset,
    id: "".concat(id ? id : 'BestProduct'),
    className: "counter ",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      fluid: true,
      className: 'bestproduct',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          md: {
            span: 11,
            offset: 0
          },
          className: 'bestproduct__info',
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            alt: 'Best Product',
            src: 'images/static/vector.svg'
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: 'bestproduct__info__data',
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              md: 6,
              className: 'bestproduct__info__data__left',
              children: (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_1__["default"], {
                text: section_data === null || section_data === void 0 ? void 0 : section_data.short_desc,
                color: '#f9f9f9',
                fontSize: 40,
                lineHeight: 48,
                fontWeight: 400,
                textTransform: 'Inherit'
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              md: 6,
              className: 'bestproduct__info__data__right',
              children: (section_data === null || section_data === void 0 ? void 0 : section_data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.description)
            })]
          })]
        })
      })
    })
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "BestProduct__StyledComponent",
  componentId: "sc-qqguc9-0"
})(["position:relative;background:#f2f2f2;&:after{content:\"\";position:absolute;left:0;right:0;bottom:0;background:#3C3C3B;height:50vh;z-index:0;}.container-fluid{position:relative;z-index:2;}.bestproduct{position:relative;img{position:absolute;object-fit:cover;height:100%;top:0;right:0;bottom:0;left:-20%;@media(min-width:1550px){left:-15%;}@media(max-width:992px) and (min-width:768px){height:150%;inset:0;}@media(max-width:767px){height:115%;inset:0;}}&__info{background-color:#978C21;position:relative;padding:160px 70px 100px;&__data{display:flex;&__left{.title{max-width:80%;}}&__right{ul{li{position:relative;counter-increment:count;padding:0 0 0 75px;border-bottom:1px solid #C4C4C4;margin:0 0 80px;@media(max-width:767px){margin-bottom:40px;}flex:0 0 calc(50% - 15px);&:before{content:counter(count,Numeric);position:absolute;padding:0;color:#F9F9F9;top:10px;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:60px;font-weight:500;line-height:60px;font-family:", ";}&:last-child{border-bottom:none;}p{font-size:24px;line-height:32px;font-weight:500;color:#FFFFFF;margin-bottom:80px;@media(max-width:767px){margin-bottom:40px;}span{margin-bottom:20px;display:inline-block;font-size:20px;line-height:28px;font-weight:500;color:#FFFFFF;&:after{content:\"\\a\";white-space:pre;}}}}}}}}@media(max-width:767px){overflow:hidden;.bestproduct{&__info{padding:120px 0;&__data{display:initial;&__left{margin-bottom:40px;.title{max-width:100%;}}&__right{ul{li{padding:0;&:before{position:unset;display:block;padding-bottom:20px;}}}}}}}}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_8__/* .title */ .TN);
/* harmony default export */ __webpack_exports__["Z"] = (MyComponent);

/***/ }),

/***/ 94917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30653);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68019);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var MyComponent = function MyComponent(_ref) {
  var _data$posts;

  var data = _ref.data;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_list = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      nav1 = _useState[0],
      setNav1 = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      nav2 = _useState2[0],
      setNav2 = _useState2[1];

  var slider1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var slider2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, [data]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledComponent, {
    className: "SliderCount pt-200 pb-200",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          md: 4,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "slider_wrapper_right",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "slider_wrapper_right__init",
              children: [(section_data === null || section_data === void 0 ? void 0 : section_data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h3", {
                "data-lag": '0.5',
                className: 'split-up',
                children: "Our Core Values"
              }), section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                "data-lag": '0.5',
                className: "footer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
                  className: "slider-nav",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                    onClick: function onClick() {
                      var _slider2$current;

                      return slider2 === null || slider2 === void 0 ? void 0 : (_slider2$current = slider2.current) === null || _slider2$current === void 0 ? void 0 : _slider2$current.slickPrev();
                    },
                    className: 'slider-prev',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "44",
                      viewBox: "0 0 44 44",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                        id: "Group_19811",
                        "data-name": "Group 19811",
                        transform: "translate(-264 -3119)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                          id: "Arrow",
                          transform: "translate(939.5 4742.5) rotate(180)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                            id: "Group_4823",
                            "data-name": "Group 4823",
                            transform: "translate(653.5 1596.5)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                              id: "Line_9",
                              "data-name": "Line 9",
                              x2: "5",
                              y2: "5",
                              fill: "none",
                              stroke: "#fff",
                              strokeLinecap: "round",
                              strokeWidth: "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                              id: "Line_10",
                              "data-name": "Line 10",
                              x1: "5",
                              y2: "5",
                              transform: "translate(0 5)",
                              fill: "none",
                              stroke: "#fff",
                              strokeLinecap: "round",
                              strokeWidth: "1"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                            id: "Line_11",
                            "data-name": "Line 11",
                            x2: "10",
                            transform: "translate(648.5 1601.5)",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                          id: "Ellipse_614",
                          "data-name": "Ellipse 614",
                          transform: "translate(308 3163) rotate(180)",
                          fill: "none",
                          stroke: "#fff",
                          strokeWidth: "1",
                          opacity: "0.3",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                            cx: "22",
                            cy: "22",
                            r: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                            cx: "22",
                            cy: "22",
                            r: "21.5",
                            fill: "none"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                          id: "Ellipse_615",
                          "data-name": "Ellipse 615",
                          transform: "translate(308 3163) rotate(180)",
                          fill: "none",
                          stroke: "#fff",
                          strokeWidth: "1",
                          strokeDasharray: "0 142",
                          opacity: "0",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                            cx: "22",
                            cy: "22",
                            r: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                            cx: "22",
                            cy: "22",
                            r: "21.5",
                            fill: "none"
                          })]
                        })]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                    onClick: function onClick() {
                      var _slider2$current2;

                      return slider2 === null || slider2 === void 0 ? void 0 : (_slider2$current2 = slider2.current) === null || _slider2$current2 === void 0 ? void 0 : _slider2$current2.slickNext();
                    },
                    className: 'slider-next',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("svg", {
                      id: "Button_-_Nav_-_Outline",
                      "data-name": "Button - Nav - Outline",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "44",
                      viewBox: "0 0 44 44",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                        id: "Arrow",
                        transform: "translate(-631.5 -1579.5)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                          id: "Group_4823",
                          "data-name": "Group 4823",
                          transform: "translate(653.5 1596.5)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                            id: "Line_9",
                            "data-name": "Line 9",
                            x2: "5",
                            y2: "5",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                            id: "Line_10",
                            "data-name": "Line 10",
                            x1: "5",
                            y2: "5",
                            transform: "translate(0 5)",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("line", {
                          id: "Line_11",
                          "data-name": "Line 11",
                          x2: "10",
                          transform: "translate(648.5 1601.5)",
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                        id: "Ellipse_614",
                        "data-name": "Ellipse 614",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1",
                        opacity: "0.3",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                        id: "Ellipse_615",
                        "data-name": "Ellipse 615",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1",
                        strokeDasharray: "0 142",
                        opacity: '0',
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "21.5",
                          fill: "none"
                        })]
                      })]
                    })
                  })]
                })
              }), section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                asNavFor: nav1,
                ref: slider2,
                arrows: false,
                dots: false,
                speed: 2000,
                ease: '',
                slidesToShow: 1,
                swipeToSlide: true,
                focusOnSelect: true,
                children: section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 0 && (section_list === null || section_list === void 0 ? void 0 : section_list.map(function (e, index) {
                  var _e$data, _e$data2, _e$data3, _e$data4;

                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                    "data-lag": '0.5',
                    className: "single-item_content",
                    children: [(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h4", {
                      children: e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.title
                    }), (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.description)
                    })]
                  }, index);
                }))
              })]
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          md: {
            span: 7,
            offset: 1
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "slider-wrapper-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "slider-wrapper-left__init",
              children: section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                asNavFor: nav2,
                fade: true,
                speed: 2000,
                arrows: false,
                ref: slider1,
                children: section_list && (section_list === null || section_list === void 0 ? void 0 : section_list.length) > 0 && (section_list === null || section_list === void 0 ? void 0 : section_list.map(function (e, index) {
                  var _e$images, _e$images$;

                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                    className: "single-item",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                      className: "image-wrapper",
                      children: (e === null || e === void 0 ? void 0 : e.images) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .E, {
                        alt: 'Shanta Securities Limited',
                        src: e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$ = _e$images[0]) === null || _e$images$ === void 0 ? void 0 : _e$images$.full_path
                      })
                    })
                  }, index);
                }))
              })
            })
          })
        })]
      })
    })
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CoreValues__StyledComponent",
  componentId: "sc-1ay8vnp-0"
})(["background:#3C3C3B;position:relative;overflow:hidden;.container,.container-fluid{position:relative;z-index:2;}.slider-wrapper-left{&__init{@media (max-width:992px){.slick-list{margin-bottom:-8px !important;}}.single-item{.image-wrapper{padding-top:calc(480 / 670 * 100%);position:relative;}}}}.slider_wrapper_right{height:100%;.slider_wrapper_right__init{position:relative;height:100%;h3{font-size:44px;font-weight:500;line-height:56px;letter-spacing:-1px;color:#F9F9F9;margin-bottom:70px;}.single-item_content{h4{font-size:24px;line-height:32px;color:#FFFFFF;font-family:", ";margin-bottom:15px;}p{color:rgba(255,255,255,0.5);font-size:16px;font-weight:500;line-height:28px;}}}}.top_text{p{font-family:'Cammron Demo';font-size:32px;line-height:44px;color:#191818;margin-bottom:60px;}}.footer{display:flex;justify-content:space-between;align-items:center;position:absolute;left:0;right:0;bottom:0px;.count{p{color:rgba(247,244,244,0.5);font-size:16px;font-weight:600;line-height:28px;}.current{font-size:32px;font-weight:600;line-height:44px;color:#F7F4F4;margin-right:8px;}.total{color:rgba(247,244,244,0.5);font-size:16px;font-weight:600;line-height:28px;}}.slider-nav{display:flex;li:first-child{margin-right:30px;}li{svg{cursor:pointer;#Ellipse_615{transition:1s all cubic-bezier(.25,.74,.22,.99);}&:hover{#Ellipse_615{opacity:1;stroke-dasharray:142px;}}}}}}@media (max-width:992px) and (min-width:768px){.slider-wrapper-left{height:100%;.slider-wrapper-left__init{height:100%;.slick-slider{height:100%;.slick-list{height:100%;.slick-track{height:100%;.slick-slide{height:100%;> div{height:100%;}.single-item{height:100%;}}}}}}}}@media (max-width:992px){&:after{height:100px;z-index:0;}.slider-wrapper-left{&__init{.slick-list{margin-bottom:-8px !important;}.single-item{.image-wrapper{height:100%;}}}}h3{margin-bottom:40px !important;}.footer{padding:0;margin-bottom:40px !important;position:relative;.slider-nav{li:first-child{margin-right:15px;}li{svg{height:50px;width:50px;}}}.slick-slider{margin:0 0 -10px;}}}@media(max-width:767px){.slider-wrapper-left{margin-top:40px;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .title */ .TN);
/* harmony default export */ __webpack_exports__["Z"] = (MyComponent);

/***/ }),

/***/ 31782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31555);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68019);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68312);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93264);
/* harmony import */ var _PopupV1__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73957);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
















var RandomSliderV1 = function RandomSliderV1(_ref) {
  var offset = _ref.offset,
      title = _ref.title,
      padding = _ref.padding,
      data = _ref.data,
      winWidth = _ref.winWidth;
  var expert = data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      popupId = _useState2[0],
      setPopupId = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow(e) {
    setShow(true);
    setPopupId(e);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledBlog, {
    offset: offset,
    className: "blog-slider  ".concat(padding ? padding : 'pt-200'),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          md: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_6__["default"], {
            margin: '0 0 75px 0',
            noanim: true,
            text: title ? title : title = 'Our <span>Board</span>'
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: " fade-up blog-slider__slider-wrap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "blog-slider__slider-wrap__inner row",
          children: expert && (expert === null || expert === void 0 ? void 0 : expert.length) > 0 && (expert === null || expert === void 0 ? void 0 : expert.map(function (e, index) {
            var _e$images, _e$images$list, _e$images$list$, _e$data, _e$data2, _e$data3, _e$data4;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              md: 4,
              className: 'single-expert',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                onClick: function onClick() {
                  return handleShow(e);
                },
                className: "single-expert-item",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "img-wrp",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .E, {
                    alt: 'Shanta Securities Limited',
                    src: e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$list = _e$images.list) === null || _e$images$list === void 0 ? void 0 : (_e$images$list$ = _e$images$list[0]) === null || _e$images$list$ === void 0 ? void 0 : _e$images$list$.full_path
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "content",
                  children: [(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h5", {
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.title)
                  }), (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.link) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.link)
                  })]
                })]
              })
            });
          }))
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_PopupV1__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      show: show,
      winWidth: winWidth,
      data: popupId,
      handleClose: handleClose
    })]
  });
};

var StyledBlog = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Expert__StyledBlog",
  componentId: "sc-19dqqjm-0"
})(["padding-bottom:120px;.mobile{display:none;}.single-expert{margin-bottom:80px;cursor:pointer;.single-expert-item{.img-wrp{padding-top:calc(370 / 370 * 100%);position:relative;overflow:hidden;.global-image{overflow:hidden;img{transition:1s all cubic-bezier(.25,.74,.22,.99);transform:scale(1.01);}}}.content{margin-top:20px;h5{font-size:20px;font-weight:500;line-height:28px;color:#3C3C3B;margin-bottom:0;}p{font-size:16px;font-weight:500;line-height:28px;color:rgba(60,60,59,0.5);}}&:hover{.global-image{img{transform:scale(1.06);}}h5{color:", "}}}@media(max-width:767px){margin-bottom:30px;&:last-child{margin-bottom:0;}}}.filter{margin-bottom:80px;ul{display:flex;gap:30px;flex-wrap:wrap;justify-content:center;}}.blog-title{position:relative;p{position:absolute;top:0;right:0;}}.load{.dc-btn{display:flex;align-items:center;justify-content:center;margin-top:50px;}}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{content:'';height:100%;width:100%;background-color:#3C3C3B;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:60px;color:#FFFFFF;font-family:'Avenir Book';line-height:60px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.blog-single__inner__content__top{h2{opacity:0;transform:translateY(-20px);}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}@media (max-width:767px){.blog-single__inner__content__top{p,h2{left:30px;right:30px;top:30px;}}.blog-single__inner__content__bottom h4,.blog-single__inner__content__bottom p{left:30px;right:30px;top:30px;}.swiper-initialized{margin-left:0;padding-right:0;}.blog-slider{&__slider-wrap{.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;.slider-nav{display:none;}}.slider-nav-mobile{display:block;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_14__/* .hover */ .Mr, _Title__WEBPACK_IMPORTED_MODULE_6__["default"]);
/* harmony default export */ __webpack_exports__["Z"] = (RandomSliderV1);

/***/ }),

/***/ 49982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68019);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








 // import Button from "../ButtonOpenNow";
// import ButtonB from "../ButtonBrochure";



var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 265).then(__webpack_require__.bind(__webpack_require__, 70265));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70265)];
    }
  }
});
var ButtonB = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6435).then(__webpack_require__.bind(__webpack_require__, 46435));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46435)];
    }
  }
});

var LubeSolution = function LubeSolution(_ref) {
  var _data$section_data, _data$section_data2, _data$section_data3, _data$images, _data$images$list, _data$images$list$, _data$section_data4, _data$section_data5, _data$section_data6, _data$posts, _data$images2, _data$images2$list;

  var padding = _ref.padding,
      data = _ref.data,
      title = _ref.title,
      subtitle = _ref.subtitle,
      text = _ref.text,
      brochure = _ref.brochure,
      bigtitle = _ref.bigtitle,
      image = _ref.image,
      link = _ref.link,
      winWidth = _ref.winWidth,
      offsetContainer = _ref.offsetContainer,
      offset = _ref.offset;
  text = data === null || data === void 0 ? void 0 : (_data$section_data = data.section_data) === null || _data$section_data === void 0 ? void 0 : _data$section_data.description;
  title = data === null || data === void 0 ? void 0 : (_data$section_data2 = data.section_data) === null || _data$section_data2 === void 0 ? void 0 : _data$section_data2.subtitle;
  subtitle = data === null || data === void 0 ? void 0 : (_data$section_data3 = data.section_data) === null || _data$section_data3 === void 0 ? void 0 : _data$section_data3.short_desc;
  image = data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : (_data$images$list = _data$images.list) === null || _data$images$list === void 0 ? void 0 : (_data$images$list$ = _data$images$list[0]) === null || _data$images$list$ === void 0 ? void 0 : _data$images$list$.full_path;
  link = data === null || data === void 0 ? void 0 : (_data$section_data4 = data.section_data) === null || _data$section_data4 === void 0 ? void 0 : _data$section_data4.extra_field;
  var brochure_link = data === null || data === void 0 ? void 0 : (_data$section_data5 = data.section_data) === null || _data$section_data5 === void 0 ? void 0 : _data$section_data5.brochure;
  var top_description = data === null || data === void 0 ? void 0 : (_data$section_data6 = data.section_data) === null || _data$section_data6 === void 0 ? void 0 : _data$section_data6.top_description;
  var banner = null;
  var thumb = null;
  var thumbBottom = null;
  var thumbDark = null;
  var thumbDarkDesktop = null;
  var postList = null;
  postList = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;
  data === null || data === void 0 ? void 0 : (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : (_data$images2$list = _data$images2.list) === null || _data$images2$list === void 0 ? void 0 : _data$images2$list.map(function (e) {
    if ((e === null || e === void 0 ? void 0 : e.banner) === "on") {
      banner = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.background) === "on") {
      thumbBottom = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.thumb) === "on") {
      thumb = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.is_dark) === "on") {
      thumbDark = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.is_dark_desktop) === "on") {
      thumbDarkDesktop = e === null || e === void 0 ? void 0 : e.full_path;
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth > 767) {
        var containerOffsetLeft = document.querySelector(".container").offsetLeft;
        var lubeTestingImgBox = document.querySelector(".lube-testing__img__box");
        var lubeTestingImgBox2 = document.querySelector(".lube-testing__text");
        var marginLeft = containerOffsetLeft + 15;
        lubeTestingImgBox.style.setProperty("left", "".concat(offsetContainer + 15, "px"));
        lubeTestingImgBox2.style.setProperty("padding-right", "".concat(marginLeft, "px"));
      }
    };

    handleResize(); // Initial positioning

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to(".hide", {
      alpha: 1,
      visibility: "visible",
      display: "block",
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  console.log(postList, "data?.section_data");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledLubeSolution, {
    offset: offset,
    className: "lube-testing  ".concat(padding ? padding : " pt-200"),
    children: [bigtitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          className: "bigtitle",
          md: 12,
          children: top_description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            className: "split-up",
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(top_description)
          })
        })
      })
    }) : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      fluid: true,
      className: "p-0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 5,
          className: "lube-testing__img",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "lube-testing__img__inner ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "",
              children: banner ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_4__/* .Img */ .E, {
                alt: "Shanta Securities Limited",
                src: banner ? banner : "/images/static/blur.jpg"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_4__/* .Img */ .E, {
                alt: "Shanta Securities Limited",
                src: image ? image : "/images/static/blur.jpg"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "lube-testing__img__box",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: "lube-testing__img__box__inner box ",
              children: [title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h5", {
                className: "split-up",
                children: title ? (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(title) : "An organization dedicated to securing your future"
              }) : "", brochure ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonB, {
                src: brochure_link ? brochure_link : "https://portal.shantasecurities.com/signup",
                text: "Open an Account Now",
                margin: "30px 0 0 0",
                background: "transparent",
                color: "#fff",
                icon: true,
                borderColor: "#000"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
                target: "_blank",
                link: link,
                text: "Open an Account Now",
                margin: "30px 0 0 0",
                background: "transparent",
                color: "#fff",
                icon: true
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 7,
          "data-lag": "0.1",
          className: "lube-testing__text",
          children: [subtitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h5", {
            className: "split-up",
            children: subtitle ? subtitle : "Investing in finance allows you to diversify your portfolio. Putting all your money in a single asset or keeping it in cash can be risky. By diversifying your investments, you can reduce the impact of any one investment's performance on your overall portfolio."
          }) : "", text ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: "split-up",
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(text)
          }) : "", winWidth > 767 ? thumbBottom ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
            alt: "Shanta Securities Limited",
            className: "new_img",
            src: thumbBottom ? thumbBottom : "/images/static/blur.jpg"
          }) : "" : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "d-flex shanta-all-brand-list",
            children: postList && postList.length > 0 && postList.map(function (item, index) {
              var _item$images, _item$images2, _item$data, _item$data2, _item$data3;

              var darkImg = item === null || item === void 0 ? void 0 : (_item$images = item.images) === null || _item$images === void 0 ? void 0 : _item$images.find(function (f) {
                return (f === null || f === void 0 ? void 0 : f.background) === "on";
              });
              var lightImg = item === null || item === void 0 ? void 0 : (_item$images2 = item.images) === null || _item$images2 === void 0 ? void 0 : _item$images2.find(function (f) {
                return (f === null || f === void 0 ? void 0 : f.is_dark) === "on";
              });
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
                style: {
                  display: "inline-block",
                  height: "100px"
                },
                href: (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.subtitle,
                target: "_blank",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  alt: (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.title,
                  className: "image-light-theme",
                  src: lightImg ? lightImg === null || lightImg === void 0 ? void 0 : lightImg.full_path : "/images/static/blur.jpg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  alt: (_item$data3 = item.data) === null || _item$data3 === void 0 ? void 0 : _item$data3.title,
                  className: "image-dark-theme",
                  src: darkImg ? darkImg === null || darkImg === void 0 ? void 0 : darkImg.full_path : "/images/static/blur.jpg"
                })]
              }, index);
            })
          })]
        })]
      })
    })]
  });
};

var StyledLubeSolution = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Invest__StyledLubeSolution",
  componentId: "sc-hgsax5-0"
})(["background-color:#ffffff;margin-bottom:-25px;@media (max-width:767px){overflow:hidden;}.new_img,.dark_image,.dark_image_deskotp{margin-top:40px;}.dark_image,.dark_image_deskotp{display:none;}.lube-testing__img__box{padding-left:", ";}@media (max-width:767px){.dark_image_deskotp{display:none;}.lube-testing__img__box{padding-left:unset;}}.bigtitle{font-size:32px;font-weight:500;line-height:44px;color:#3c3c3b;font-family:", ";margin-bottom:75px;span{color:", ";}}.lube-testing__img{position:relative;top:-25px;padding-right:55px;&__inner{padding-top:calc(420 / 528 * 100%);position:relative;min-height:100%;}.reveal{height:100%;}&__box{position:absolute;bottom:-75px;&__inner{height:216px;width:335px;position:relative;background-color:#978c21;z-index:222;h5{font-size:20px;line-height:28px;color:#ffffff;font-weight:500;position:absolute;top:30px;left:30px;right:30px;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;white-space:normal;overflow:hidden;}}.dc-btn{position:absolute;bottom:30px;left:30px;}}}.lube-testing__text{justify-content:flex-start;display:flex;flex-direction:column;h5{font-size:24px;line-height:28px;font-weight:500;margin-bottom:40px;color:#3c3c3b;font-family:", ";}p{font-size:16px;line-height:24px;font-weight:500;margin-bottom:0;color:#3c3c3b;span{color:", ";}&:nth-last-child(1){margin-bottom:0;}}}@media (max-width:991px){.lube-testing__img{padding-right:0;}.lube-testing__text{padding-left:75px;}.lube-testing__img__box{&__inner{}}}@media (min-width:768px) and (max-width:1150px){.lube-testing__img__box{&__inner h2{font-size:22px;line-height:26px;}}}@media (max-width:767px){padding-bottom:0;margin-bottom:-25px;.row{flex-direction:column-reverse;}.col-sm-5,.col-sm-6{min-width:100%;margin:0;}.lube-testing__img{padding-right:0 !important;margin-top:60px;}.lube-testing__img__box{left:0 !important;position:relative;right:0 !important;bottom:0 !important;&__inner{width:100% !important;h5{font-size:20px;line-height:24px;}}}.lube-testing__text{padding:0 30px !important;margin-top:0;}}"], function (props) {
  return props.offset ? props.offset + "px" : "";
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .title */ .TN, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .title */ .TN, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(LubeSolution));

/***/ })

}]);